"use client";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { ProductCardRedesignTestResult } from "@/monarch/rules/productCardRedesign/types";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import { Skeleton } from "@/components/ui/skeleton";
import { MobileShowAllResultsButtonProps } from "./types";
import MobileShowAllResultsButton from "./v1";
import MobileShowAllResultsButtonV2 from "./v2";

export default function MobileShowAllResultsButtonWrapper(
  props: MobileShowAllResultsButtonProps,
) {
  return (
    <ClientOnly>
      <MonarchResolver<ProductCardRedesignTestResult>
        experimentKey="useProductCardRedesign"
        variants={{
          control: <MobileShowAllResultsButton {...props} />,
          test: <MobileShowAllResultsButtonV2 {...props} />,
        }}
        fallbackVariant="control"
        Loader={
          <div className="flex justify-center lg:hidden">
            <Skeleton variant="productCard" className="rounded-xl" />
          </div>
        }
      />
    </ClientOnly>
  );
}
